import styles from './MyInfo.module.scss'
import { ChevronRightIcon } from '@heroicons/react/24/solid'
import { useNavigate } from 'react-router-dom'
import { useUser } from '../../hooks'

export const MyInfo = () => {
	const navigate = useNavigate()
	const { data: user } = useUser()
	return (
		<div className={styles.myInfoWrapper}>
			<div className={styles.myInfoLabel}>
				<span className={styles.myInfoTitle}>설정</span>
				<span className={styles.explain}>계정 정보를 확인하고 관리해보세요</span>
			</div>
			<div className={styles.myInfoMenu}>
				<div className={styles.infoOption} onClick={() => navigate('/myinfo/basicinfo')}>
					<span className={styles.optionTitle}>
						<span className={styles.optionLabel}>기본 정보</span>
						<span className={styles.optionExplain}>계정, 연락처, 서비스 동의 등</span>
					</span>
					<ChevronRightIcon style={{ width: '16px', height: '16px', color: '#A0A0A0' }} />
				</div>
				{user?.userType === 'tourPro' ? (
					<div className={styles.infoOption} onClick={() => navigate('/myinfo/proinfo')}>
						<span className={styles.optionTitle}>
							<span className={styles.optionLabel}>내 선수 정보</span>
							<span className={styles.optionExplain}>
								영문명, 회원번호, 스폰서 등
							</span>
						</span>
						<ChevronRightIcon
							style={{ width: '16px', height: '16px', color: '#A0A0A0' }}
						/>
					</div>
				) : (
					<>
						<div
							className={styles.infoOption}
							onClick={() => navigate('/myinfo/caddieinfo')}>
							<span className={styles.optionTitle}>
								<span className={styles.optionLabel}>내 캐디 정보</span>
								<span className={styles.optionExplain}>
									경력, 구단, 선호 투어 등
								</span>
							</span>
							<ChevronRightIcon
								style={{ width: '16px', height: '16px', color: '#A0A0A0' }}
							/>
						</div>
						<div
							className={styles.infoOption}
							onClick={() => navigate('/myinfo/bank-account')}>
							<span className={styles.optionTitle}>
								<span className={styles.optionLabel}>정산 계좌 관리</span>
								<span className={styles.optionExplain}>
									은행명, 계좌번호, 예금주 관리
								</span>
							</span>
							<ChevronRightIcon
								style={{ width: '16px', height: '16px', color: '#A0A0A0' }}
							/>
						</div>
					</>
				)}
				<div
					className={styles.infoOption}
					onClick={() => navigate('/myinfo/preferred-contract')}>
					<span className={styles.optionLabel}>선호 계약 정보</span>
					<ChevronRightIcon style={{ width: '16px', height: '16px', color: '#A0A0A0' }} />
				</div>
				{user?.userType === 'tourPro' && (
					<div
						className={styles.infoOption}
						onClick={() => navigate('/myinfo/upcomingtournaments')}>
						<span className={styles.optionLabel}>출전 예정 대회</span>
						<ChevronRightIcon
							style={{ width: '16px', height: '16px', color: '#A0A0A0' }}
						/>
					</div>
				)}
				{/* <div className={styles.infoOption}>
					<span className={styles.optionLabel}>계정 위임 에이전시</span>
					<ChevronRightIcon style={{ width: '16px', height: '16px', color: '#A0A0A0' }} />
				</div> */}
			</div>
		</div>
	)
}
